import {
    ADD_COMPANY_ERROR,
    ADD_COMPANY_PENDING,
    ADD_COMPANY_SUCCESS, CLEAR_FILTER_COMPANIES,
    CLEAR_NEWLY_ADDED_COMPANY, FILTER_COMPANIES_PENDING, FILTER_COMPANIES_SUCCESS,
    GET_COMPANIES_ERROR,
    GET_COMPANIES_PENDING,
    GET_COMPANIES_SUCCESS
} from "../actions/types";
import {useSelector} from "react-redux";

const INITIAL_STATE = {
    companies: [],
    loading: false,
    companySavePending: false,
    newCompany: null,
    filterValues: [],
    filteredCompanies: []
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_COMPANIES_PENDING:
            return {
                ...state,
                loading: true
            };
        case GET_COMPANIES_SUCCESS:
            return {
                ...state,
                loading: false,
                filteredCompanies: action.payload,
                companies: action.payload
            };
        case GET_COMPANIES_ERROR:
            return {
                ...state,
                loading: false,
                companies: []
            };
        case ADD_COMPANY_PENDING:
            return {
                ...state,
                companySavePending: true,
                newCompany: null
            };
        case ADD_COMPANY_SUCCESS:
            return {
                ...state,
                companySavePending: false,
                newCompany: action.payload
            };
        case ADD_COMPANY_ERROR:
            return {
                ...state,
                companySavePending: false,
                newCompany: null
            };
        case CLEAR_NEWLY_ADDED_COMPANY: {
            return {
                ...state,
                newCompany: null
            }
        }
        case FILTER_COMPANIES_PENDING:
            return {
                ...state,
                filterValues: action.payload
            };
        case FILTER_COMPANIES_SUCCESS:
            return {
                ...state,
                filteredCompanies: action.payload
            };
        case CLEAR_FILTER_COMPANIES:
            return {
                ...state,
                filterValues: []
            };

        default: return state;
    }
}

export const companySelector = () => state => state.company;

export const useCompanySelector = () => useSelector(companySelector());